<template>
  <div
      class="file-drop-zone"
      :class="{ 'is-dragover': isDragOver }"
      @dragenter="handleDragEnter"
      @dragleave="handleDragLeave"
      @drop="handleDrop"
  >
    <div class="drop-content">
      <h2 class="entity-name ellipsis">
				{{ entity?.name }}
			</h2>

      <p class="drop-instruction">
        Для загрузки перетащите файлы в это поле
      </p>
    </div>
  </div>
</template>

<style lang="scss" src="./VFilesDropZone.scss"/>

<script lang="ts">

import FilesService from '@/core/services/Files/FilesService';

export default defineComponent({
  name: 'VFilesDropZone',

  props: {
    /**
     * Сущность к которой привязывается файл
     * @type {EntityPointer}
     */
    entity: {
      type: Object,
      required: true,
    },
		/** проп нужен для предпросмотра файлов в таблице, их подтверждения и только потом их загрузки */
		disableUpload: {
			type: Boolean,
			default: false,
		},
    /** Режим одного файла - скрывает кнопки загрузки если файл уже есть */
    maxOneFile: {
      type:    Boolean,
      default: false,
    },
  },

  data() {
    return {
      isDragOver: false,
      dragCounter: 0
    };
  },

  methods: {
    handleDragEnter() {
      this.dragCounter++;
      this.isDragOver = true;
    },

    handleDragLeave() {
      this.dragCounter--;
      if (this.dragCounter === 0) {
        this.isDragOver = false;
      }
    },

    async handleDrop(event) {
      this.isDragOver = false;
      this.dragCounter = 0;

			/** реализуем дроп без загрузки для превью в таблице */
			if (this.disableUpload) return;

      const files = Array.from(event.dataTransfer?.files || []);

      // dataTransfer.files - это readonly свойство.
      // из-за этого мы не можем срезать файлы, мы можем только кинуть ошибку
      if (
          this.maxOneFile
          && files.length > 1
      ) {
        this.$core.error('Вы можете прикрепить только один файл');
        return;
      }
      await FilesService.handleDrop(event, this.entity);
    }
  }
});
</script>
